
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { areProPopupTriggersUsed } from "@/lib/subscriptions/free-mode";
import { Trigger } from "@/types/conditions";
import ProOnlyAlertBox from "@/components/Subscription/ProOnlyAlertBox.vue";
import { PopupTriggers } from "@/subapps/manage-templates/types";
@Component({
  components: { ProOnlyAlertBox }
})
export default class FreeModeAlertForPopupTriggers extends Vue {
  @Prop()
  value!: Trigger[];

  @Prop()
  triggers!: PopupTriggers[];

  get areProTriggersUsed() {
    return areProPopupTriggersUsed(this.value, this.triggers);
  }
}
